import React from 'react';
import { Image, Platform } from 'react-native';
import { createStyleSheet } from '../../../../utils';
import { useStyleSheet, useThemeContext } from '../../../../hooks';
import { AUDIO_TYPES, VIDEO_TYPES, IMAGE_TYPES } from '../../../../constants';
import { View } from '../../../View';
import { Icon } from '../../../Icon';
import { Text } from '../../../Text';
import { Focusable } from '../../../Focusable';
import { Progress } from '../../../Progress';
import { useFileInputContext } from '../../hooks';
import { FileStatus } from '../../types';
export const Files = () => {
    const styles = useStyleSheet(getStyles);
    const { size } = useThemeContext();
    const { files, remove } = useFileInputContext();
    return (React.createElement(View, { style: styles.container }, files.map((file) => {
        var _a;
        return (React.createElement(View, { key: file.id, style: styles.file },
            file.type === 'application/pdf' ? (React.createElement(View, { style: [styles.preview, styles.preview__pdf] },
                React.createElement(Icon, { name: 'document-pdf', size: size.J, color: (color) => color.invert2.p26 }))) : AUDIO_TYPES.includes(file.type) ? (React.createElement(View, { style: [styles.preview, styles.preview__pdf] },
                React.createElement(Icon, { name: 'device-eq', size: size.J, color: (color) => color.invert2.p26 }))) : VIDEO_TYPES.includes(file.type) ? (React.createElement(View, { style: [styles.preview, styles.preview__pdf] },
                React.createElement(Icon, { name: 'video', size: size.J, color: (color) => color.invert2.p26 }))) : IMAGE_TYPES.includes(file.type) ? (React.createElement(Image
            // TODO
            // ideally we should have some fallback image here, in case
            // we were not able to read file and load preview
            , { 
                // TODO
                // ideally we should have some fallback image here, in case
                // we were not able to read file and load preview
                source: {
                    uri: file.status === FileStatus.Uploading
                        ? Platform.OS === 'web'
                            ? (_a = file.preview) !== null && _a !== void 0 ? _a : ''
                            : file.uri
                        : file.data
                }, style: styles.preview })) : (React.createElement(View, { style: [styles.preview, styles.preview__document] },
                React.createElement(Icon, { name: 'document', size: size.J, color: (color) => color.invert2.p26 }))),
            React.createElement(View, { style: styles.main },
                React.createElement(Text, { type: 'body', size: 'md', weight: 'semibold', style: styles.name, numberOfLines: 1 }, file.name),
                React.createElement(Text, { type: 'body', size: 'sm', weight: 'regular', style: styles.info, numberOfLines: 1 }, file.type.split('/')[1].toUpperCase())),
            React.createElement(Focusable, { onPress: () => {
                    remove(file.id);
                }, style: styles.dismiss }, ({ hovered }) => hovered || file.status !== FileStatus.Uploading ? (React.createElement(Icon, { name: 'dismiss', size: size.E, color: (color) => color.invert2.p68 })) : (React.createElement(Progress, { value: file.progress, radius: size.E / 2, outline: 2 })))));
    })));
};
const getStyles = createStyleSheet(({ color, size }) => ({
    container: {
        marginLeft: -size.C,
        flexDirection: 'row',
        flexWrap: 'wrap'
    },
    file: {
        backgroundColor: color.invert2.p4,
        paddingVertical: size.C,
        paddingLeft: size.C,
        paddingRight: size.I,
        borderRadius: size.G,
        flexBasis: 275,
        flexDirection: 'row',
        alignItems: 'center',
        marginLeft: size.C,
        marginTop: size.C
    },
    preview: {
        width: 49,
        height: 49,
        borderRadius: size.D,
        borderColor: color.invert2.p4,
        borderWidth: 1,
        marginRight: size.C
    },
    preview__pdf: {
        backgroundColor: color.bg.v1,
        padding: size.E
    },
    preview__document: {
        backgroundColor: color.bg.v1,
        padding: size.E
    },
    main: {
        flex: 1
    },
    name: {
        color: color.invert2.p100
    },
    info: {
        color: color.invert2.p56
    },
    dismiss: {
        position: 'absolute',
        width: size.I,
        height: size.I,
        alignItems: 'center',
        justifyContent: 'center',
        top: -7,
        right: -7,
        borderRadius: 9999,
        borderWidth: 1,
        borderColor: color.invert2.p4,
        backgroundColor: color.bg.v1
    }
}));
//# sourceMappingURL=index.js.map